declare const THREE: any;

const setupZoom = ({
  canvasRef,
  camera,
  controls,
  renderer,
  scene,
}: {
  canvasRef: any;
  camera: any;
  controls: any;
  renderer: any;
  scene: any;
}): void => {
  const onMouseWheelChange = (e: any) => {
    if (e === undefined || canvasRef.current === null) {
      return;
    }

    const factor = 150;
    e.preventDefault();

    const mX = (e.clientX / canvasRef.current.clientWidth) * 2 - 1;
    const mY = -(e.clientY / canvasRef.current.clientHeight) * 2 + 1;
    const vector = new THREE.Vector3(mX, mY, 0.5);

    vector.unproject(camera);
    vector.sub(camera.position);

    if (e.deltaY < 0) {
      camera.position.addVectors(camera.position, vector.setLength(factor));
      controls.target.addVectors(controls.target, vector.setLength(factor));
      camera.updateProjectionMatrix();
    } else {
      camera.position.subVectors(camera.position, vector.setLength(factor));
      controls.target.subVectors(controls.target, vector.setLength(factor));
    }

    renderer.render(scene, camera);
  };

  document.addEventListener('mousewheel', onMouseWheelChange, {
    passive: false,
  });
};

export default setupZoom;
